<script setup lang="ts">
import { useKeycloak } from '@future-harry/nxt-keycloak';
import { NxtErrorPage } from '@future-harry/nxt-styles';

const { query } = useRoute();
const error_title = (Array.isArray(query.error_title) ? query.error_title[0] : query.error_title) ?? '';
const error_message = (Array.isArray(query.error_message) ? query.error_message[0] : query.error_message) ?? '';
const { keycloak } = useKeycloak();

const handleLogout = () => {
   keycloak.logout({ redirectUri: window.location.origin });
};

const handleGoToHome = () => {
   window.location.href = '/';
};
</script>

<template>
   <NxtErrorPage :title="$t(error_title)" :message="$t(error_message)" @on-logout="handleLogout" @on-go-to-home="handleGoToHome" />
</template>
